module.exports = require("react");


//////////////////
// WEBPACK FOOTER
// external "react"
// module id = 21
// module chunks = 0